import { createContext } from 'react'

const WithMenuItemMetaData = createContext(null)

export default WithMenuItemMetaData
